import { FC, PropsWithChildren } from 'react';

const Instagram: FC<PropsWithChildren<unknown>> = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.45168 2.5245C4.79301 2.78065 4.23598 3.12218 3.67896 3.6792C3.12194 4.23216 2.7804 4.79325 2.52425 5.44785C2.27623 6.08213 2.10953 6.80992 2.06074 7.87518C2.01195 8.94043 1.99976 9.28197 1.99976 11.998C1.99976 14.714 2.01195 15.0555 2.06074 16.1208C2.10953 17.186 2.2803 17.9138 2.52425 18.5481C2.7804 19.2067 3.12194 19.7638 3.67896 20.3208C4.23598 20.8778 4.79301 21.2194 5.45168 21.4755C6.08595 21.7235 6.81374 21.8902 7.879 21.939C8.94426 21.9878 9.28579 22 12.0018 22C14.7178 22 15.0593 21.9878 16.1246 21.939C17.1898 21.8902 17.9176 21.7195 18.5519 21.4755C19.2106 21.2194 19.7676 20.8778 20.3246 20.3208C20.8816 19.7638 21.2232 19.2067 21.4793 18.5481C21.7273 17.9138 21.894 17.186 21.9428 16.1208C21.9916 15.0555 22.0038 14.714 22.0038 11.998C22.0038 9.28197 21.9916 8.94043 21.9428 7.87518C21.894 6.80992 21.7233 6.08213 21.4793 5.44785C21.2232 4.79325 20.8816 4.23216 20.3287 3.6792C19.7717 3.12218 19.2146 2.78065 18.556 2.5245C17.9217 2.27648 17.1939 2.10978 16.1286 2.06099C15.0634 2.0122 14.7219 2 12.0059 2C9.28985 2 8.94832 2.0122 7.88306 2.06099C6.81374 2.10571 6.08595 2.27648 5.45168 2.5245ZM16.0433 3.8581C17.0191 3.90283 17.5476 4.06546 17.9014 4.2037C18.3689 4.38666 18.7023 4.60215 19.052 4.95182C19.4017 5.30148 19.6172 5.63488 19.8001 6.10246C19.9384 6.45619 20.101 6.98475 20.1457 7.96056C20.1945 9.01362 20.2026 9.33076 20.2026 12.002C20.2026 14.6733 20.1904 14.9904 20.1457 16.0435C20.101 17.0193 19.9384 17.5479 19.8001 17.9016C19.6172 18.3692 19.4017 18.7026 19.052 19.0522C18.7023 19.4019 18.3689 19.6174 17.9014 19.8004C17.5476 19.9386 17.0191 20.1012 16.0433 20.146C14.9902 20.1948 14.6731 20.2029 12.0018 20.2029C9.33051 20.2029 9.01338 20.1907 7.96032 20.146C6.98451 20.1012 6.45595 19.9386 6.10222 19.8004C5.63464 19.6174 5.30124 19.4019 4.95158 19.0522C4.60191 18.7026 4.38642 18.3692 4.20346 17.9016C4.06522 17.5479 3.90258 17.0193 3.85786 16.0435C3.80907 14.9904 3.80093 14.6733 3.80093 12.002C3.80093 9.33076 3.81313 9.01362 3.85786 7.96056C3.90258 6.98475 4.06522 6.45619 4.20346 6.10246C4.38642 5.63488 4.60191 5.30148 4.95158 4.95182C5.30124 4.60215 5.63464 4.38666 6.10222 4.2037C6.45595 4.06546 6.98451 3.90283 7.96032 3.8581C9.01338 3.80931 9.33051 3.80118 12.0018 3.80118C14.6731 3.80118 14.9902 3.80931 16.0433 3.8581Z"
      fill="url(#paint0_radial_787_847)"
    />
    <path
      d="M6.8667 12.002C6.8667 14.84 9.16798 17.1372 12.0019 17.1372C14.8358 17.1372 17.1371 14.8359 17.1371 12.002C17.1371 9.1681 14.8399 6.86682 12.0019 6.86682C9.16391 6.86682 6.8667 9.16404 6.8667 12.002ZM15.3359 12.002C15.3359 13.8438 13.8437 15.336 12.0019 15.336C10.1601 15.336 8.66788 13.8438 8.66788 12.002C8.66788 10.1602 10.1601 8.668 12.0019 8.668C13.8437 8.668 15.3359 10.1602 15.3359 12.002Z"
      fill="url(#paint1_radial_787_847)"
    />
    <path
      d="M17.3445 7.86297C18.0069 7.86297 18.5439 7.32597 18.5439 6.66354C18.5439 6.00111 18.0069 5.46411 17.3445 5.46411C16.682 5.46411 16.145 6.00111 16.145 6.66354C16.145 7.32597 16.682 7.86297 17.3445 7.86297Z"
      fill="#654C9F"
    />
    <defs>
      <radialGradient
        id="paint0_radial_787_847"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.36373 20.1689) rotate(-3.00009) scale(28.9211 24.5826)"
      >
        <stop stopColor="#FED576" />
        <stop offset="0.2634" stopColor="#F47133" />
        <stop offset="0.6091" stopColor="#BC3081" />
        <stop offset="1" stopColor="#4C63D2" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_787_847"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.05297 16.1954) rotate(-3.00009) scale(14.8514 12.6235)"
      >
        <stop stopColor="#FED576" />
        <stop offset="0.2634" stopColor="#F47133" />
        <stop offset="0.6091" stopColor="#BC3081" />
        <stop offset="1" stopColor="#4C63D2" />
      </radialGradient>
    </defs>
  </svg>
);

export default Instagram;
